import ProductVariant from 'shop/assets/js/entities/ProductVariant';

export default class Product {
    data = {};

    constructor(data) {
        this.data = data;
        this.type = this.data['type'];
        this.variants = this.data['variants'].map((variantJson) => new ProductVariant(variantJson));
        this.enabledVariants = this.variants.filter((variant) => variant.enabled);
        this.sellableVariants = this.variants.filter((variant) => variant.sellable);
    }

    findVariantByCode(variantCode) {
        return this.variants.find((variant) => variant.code === variantCode);
    }

    findSellableVariantByCode(variantCode) {
        return this.sellableVariants.find((variant) => variant.code === variantCode);
    }

    findVariantByOptions(options) {
        // Convertir el array de options en un Set para comparaciones rápidas
        const optionsSet = new Set(options);

        return this.variants.find((variant) =>
            variant.optionValues.every((optionValue) => optionsSet.has(optionValue))
        );
    }

    findSellableVariantByOptions(options) {
        // Convertir el array de options en un Set para comparaciones rápidas
        const optionsSet = new Set(options);

        return this.sellableVariants.find((variant) =>
            variant.optionValues.every((optionValue) => optionsSet.has(optionValue))
        );
    }

    getFirstVariant() {
        if (this.data['variants'].length === 0) {
            return null;
        }

        return this.data['variants'][0];
    }

    getFirstSellableVariant() {
        if (this.data['sellable_variants'].length === 0) {
            return null;
        }

        return this.data['sellable_variants'][0];
    }

    getFirstEnabledVariant() {
        if (this.data['enabled_variants'].length === 0) {
            return null;
        }

        return this.data['enabled_variants'][0];
    }
}
